module.exports = __webpack_public_path__ + "fonts/ralewayextralight.b15e5a0.ttf";